const state = {
    leavetypes: [],
    leavetypeId: [],
    loading: false
};

export default state;